import React, { createContext, useState } from 'react';
import PropTypes from 'prop-types';

export const LoaderContext = createContext();

export const LoaderContextProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState('');

  return (
    <LoaderContext.Provider value={{loading, setLoading, loadingMessage, setLoadingMessage}}>
      {children}
    </LoaderContext.Provider>
  );
};

LoaderContextProvider.propTypes = {
  children: PropTypes.node
};
